export default __webpack_public_path__ + "febe3e8e5acf529e29bcc783e3a796ed.svg";